import { Gauge } from '@mui/x-charts';
import { type FC } from 'react';

import SpinnerLoader from '../Loaders/SpinnerLoader';

import type { GaugeComponentProps } from '@/types/monitoringTypes';

const GaugeComponent: FC<GaugeComponentProps> = ({ panelInfo, height, isLoading, panelData }) => {
  const getPanelValues = (): number => {
    if (panelData && Object.keys(panelData).length === 0) {
      return typeof panelInfo.defaultValue === 'number' ? panelInfo.defaultValue : 0;
    }

    const activeTarget = panelInfo.targets?.find(target => !target.hide);
    if (!activeTarget) {
      return typeof panelInfo.defaultValue === 'number' ? panelInfo.defaultValue : 0;
    }

    const { refId } = activeTarget;
    const frames = refId ? panelData?.results[refId]?.frames[0]?.data.values : undefined;

    if (frames && frames.length > 0) {
      const lastFrame = frames[frames.length - 1];
      const lastValue = Array.isArray(lastFrame) ? lastFrame[0] : 0;
      return typeof lastValue === 'number' ? lastValue : 0;
    }

    return typeof panelInfo.defaultValue === 'number' ? panelInfo.defaultValue : 0;
  };

  const value = getPanelValues();

  return (
    <SpinnerLoader
      isLoading={isLoading}
      height={height}
      labelText='Loading gauge data...'
    >
      <Gauge
        value={value || 0}
        text={value ? `${value.toFixed(2)} %` : 'No data'}
        startAngle={-90}
        endAngle={90}
        height={height}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
    </SpinnerLoader>
  );
};

export default GaugeComponent;
